import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class E5coreVersionService {
  constructor() { }

  public getVersion(): string {
    return '1.1.6' ;
  }
}
